import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { EventAdminDetailDto, Mission } from '@aoe/client';
import { FormHelper } from 'src/app/core/helpers/form.helper';

@Component({
  selector: 'aoe-mission',
  imports: [CommonModule, MatTabsModule, FormsModule, ReactiveFormsModule, MatDialogModule],
  templateUrl: './mission.component.html',
  styleUrl: './mission.component.scss'
})
export class MissionComponent implements OnInit {

  missionForm!: FormGroup;

  isControlRequired: (control: AbstractControl) => boolean;
  isInputValid: (control: AbstractControl) => boolean;
  displayError: (control: AbstractControl) => boolean;
  // missionTypeLabel: (type: Mission.MissionTypeEnum) => string;
  // missionType = Volunteer.MissionType.getAll();

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: { mission: Mission.MissionDto | null, event: EventAdminDetailDto; },
    readonly formHelper: FormHelper,
    private readonly fb: FormBuilder
  ) {
    this.isControlRequired = formHelper.isControlRequired;
    this.isInputValid = formHelper.isInputValid;
    this.displayError = formHelper.displayError;
    // this.missionTypeLabel = Volunteer.Mission.missionTypeLabel;
  }

  ngOnInit(): void {
    this.initForm();
  }

  get mission() {
    return this.data.mission;
  }

  private initForm() {
    this.missionForm = this.fb.group({
      label: new FormControl(this.mission?.label, [Validators.required, Validators.minLength(3)]),
      description: new FormControl(this.mission?.description),
      type: new FormControl(this.mission?.type, [Validators.required])
    })
  }

  submit() {

  }

}
